import handler from 'api/handler'

const prefix = '/public/exemptionReason'

const methods = {
  getActive: () =>handler({ method: 'get', url: prefix + '/active' })
}

export default methods
